<ng-template #helpContent>
    <span class="e2e-inner-html-bound" [innerHTML]="help"></span>
</ng-template>
<span *ngIf="help" class="edl-tooltip-icon ml-2" triggers="click" [autoClose]="'inside'" title="Help" [ngbTooltip]="helpContent">
    <i [ngClass]="icon"></i>
</span>

<ng-template #exampleContent>
    <span class="e2e-inner-html-bound" [innerHTML]="example"></span>
</ng-template>
<span *ngIf="example" class="edl-tooltip-icon ml-2" triggers="click" [autoClose]="'inside'" title="Click to show/hide example"
    [ngbTooltip]="exampleContent">
    <b>Ex</b></span>